const initialState = {
  email: "",
  isExisting: false,
  isPasswordSet: false,
};

const loginFlowReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOGIN_FLOW_DETAILS":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default loginFlowReducer;
